import { Manifestation } from "@skinsoft/types";
import { dbCacheUp } from "../dexie/cache-up";
import { OfflineDataUpdateCacher } from "../offline-data-update-cacher";

export class ManifestationOfflineDataUpdateCacher extends OfflineDataUpdateCacher<Manifestation> {
    constructor() {
        super(dbCacheUp.manifestation)
    }
}